import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ShellHeaderContext = createContext(null);

const DEFAULT_META = {
  eyebrow: '',
  title: '',
};

export function ShellHeaderProvider({ children }) {
  const [headerMeta, setHeaderMetaState] = useState(DEFAULT_META);
  const [actionSlot, setActionSlot] = useState(null);

  const setHeaderMeta = useCallback((nextMeta) => {
    const normalized = {
      eyebrow: nextMeta?.eyebrow || '',
      title: nextMeta?.title || '',
    };
    setHeaderMetaState((previous) => (
      previous.eyebrow === normalized.eyebrow && previous.title === normalized.title
        ? previous
        : normalized
    ));
  }, []);

  const clearHeaderMeta = useCallback(() => {
    setHeaderMetaState((previous) => (
      previous.eyebrow === DEFAULT_META.eyebrow && previous.title === DEFAULT_META.title
        ? previous
        : DEFAULT_META
    ));
  }, []);

  const registerActionSlot = useCallback((node) => {
    setActionSlot((previous) => (previous === node ? previous : node));
  }, []);

  const value = useMemo(() => ({
    actionSlot,
    clearHeaderMeta,
    headerMeta,
    registerActionSlot,
    setHeaderMeta,
  }), [actionSlot, clearHeaderMeta, headerMeta, registerActionSlot, setHeaderMeta]);

  return (
    <ShellHeaderContext.Provider value={value}>
      {children}
    </ShellHeaderContext.Provider>
  );
}

export function useShellHeader() {
  return useContext(ShellHeaderContext);
}
